import { EkycNextOperation, EkycSource } from '@/interface/KKC';
import { EddaManageState } from '@/interface/KKC/edda';
import VhkStore from '@/vhkstore';
import { setEkycOption } from '@/vhkstore/slices/app';
import { NavigateFunction } from 'react-router';
import { timeoutGap } from '../loading/ValidateLogic/utils';
import { queryEddaManageInfo, QueryEddaManageInfoParams } from './api';

export const checkEddaStateAndNavigate = async ({
  navigate,
  manageEddaFunc,
}: {
  navigate: NavigateFunction;
  manageEddaFunc?: () => void;
}) => {
  const navigateIfRouteNotMatch = (route: string) => {
    const currentPath = location.pathname;
    if (route !== currentPath) {
      navigate(route, { replace: true });
      return true;
    }
    return false;
  };

  const { eddaApplyId } = VhkStore.getState().eddaReducer;

  const params: QueryEddaManageInfoParams = {};
  if (eddaApplyId) {
    params.eddaApplyId = eddaApplyId;
  }
  const eddaNodeInfo = await queryEddaManageInfo(params);
  switch (eddaNodeInfo.state) {
    case EddaManageState.NO_EKYC:
      VhkStore.dispatch(
        setEkycOption({
          nextOperation: EkycNextOperation.CheckEddaState,
          source: EkycSource.Edda,
        })
      );
      navigateIfRouteNotMatch('/idCard');
      break;
    case EddaManageState.TO_BE_CONFIRM:
      navigateIfRouteNotMatch('/vhk/edda/confirmInfo');
      break;
    case EddaManageState.CONFIRM:
      navigateIfRouteNotMatch('/vhk/edda/setedda');
      break;
    case EddaManageState.EKYC_PROCESS:
    case EddaManageState.INFO_VERIFY_PROCESS:
    case EddaManageState.BINDING:
      if (!navigateIfRouteNotMatch('/vhk/edda/eddaPending')) {
        setTimeout(() => {
          checkEddaStateAndNavigate({ navigate });
        }, timeoutGap);
      }
      break;
    case EddaManageState.EKYC_FAIL:
    case EddaManageState.INFO_VERIFY_REJECT:
    case EddaManageState.FAIL:
      navigateIfRouteNotMatch('/vhk/edda/eddaFail');
      break;
    case EddaManageState.SUCCESS:
      if (!navigateIfRouteNotMatch('/vhk/edda/manageedda')) {
        manageEddaFunc?.();
      }
      break;
    default:
      if (!navigateIfRouteNotMatch('/vhk/edda/eddaPending')) {
        setTimeout(() => {
          checkEddaStateAndNavigate({ navigate });
        }, timeoutGap);
      }
      break;
  }
};
